import isObject from '@/helpers/isObject';

const isValidString = (string) => typeof string === 'string' && string !== '';

const isValidLink = (link) =>
  isValidString(link) ||
  isValidString(link.value) ||
  (isObject(link.value) && isValidString(link.value.anchor));

const showButton = {
  methods: {
    showButton(text, link) {
      if (typeof text === 'undefined' && typeof link === 'undefined') {
        return false;
      }

      return (
        (typeof text === 'undefined' || isValidString(text)) &&
        (typeof link === 'undefined' || isValidLink(link))
      );
    },
  },
};

export default showButton;
